import { render } from "./homeFooter.vue?vue&type=template&id=6d7f8ac0&scoped=true"
const script = {}

import "./homeFooter.vue?vue&type=style&index=0&id=6d7f8ac0&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7f8ac0"]])

export default __exports__